!(function () {
  "use strict";
  var e = {
      4105: function (e, t, n) {
        n.d(t, {
          Q2: function () {
            return r;
          },
          St: function () {
            return u;
          },
          gp: function () {
            return a;
          },
          hO: function () {
            return c;
          },
          zx: function () {
            return d;
          },
        });
        const r = function () {
            let e =
              arguments.length > 0 && void 0 !== arguments[0]
                ? arguments[0]
                : "json";
            return {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                Accept: `application/${e}`,
              },
            };
          },
          c = function () {
            let e =
                arguments.length > 0 && void 0 !== arguments[0] && arguments[0],
              t = window.innerWidth - document.body.offsetWidth;
            const n = document.getElementById("nav-wrapper");
            e
              ? (document.body.classList.add("no-scroll"),
                (document.body.style.paddingRight = t + "px"),
                (n.style.paddingRight = t + "px"))
              : (document.body.classList.remove("no-scroll"),
                (document.body.style.paddingRight = "0px"),
                (n.style.paddingRight = "0px"));
          };
        let o = () => {},
          i = (e) => {
            "Escape" === e.key &&
              (o(), window.removeEventListener("keydown", i));
          };
        const a = function () {
          let e =
              arguments.length > 0 && void 0 !== arguments[0] && arguments[0],
            t = arguments.length > 1 ? arguments[1] : void 0;
          t && (o = t),
            e && window.addEventListener("keydown", i),
            e || window.removeEventListener("keydown", i);
        };
        function l(e) {
          return Array.from(
            e.querySelectorAll(
              "summary, a[href], button:not([disabled]), [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
            )
          );
        }
        document.querySelectorAll(".local-scroll").forEach((e) => {
          e.addEventListener("click", (e) => {
            e.preventDefault(), e.stopPropagation();
            const t = e.target.getAttribute("href");
            ((e) => {
              Math.easeInOutQuad = function (e, t, n, r) {
                return (e /= r / 2) < 1
                  ? (n / 2) * e * e + t
                  : (-n / 2) * (--e * (e - 2) - 1) + t;
              };
              const t = document.getElementById("grid-archive-header"),
                n = document.getElementById("nav-wrapper");
              let r = 0;
              t && (r = t.offsetHeight + 50),
                n && (navWrapperOffset = n.offsetHeight + 50);
              const c = e.offsetTop - r - navWrapperOffset,
                o = window.scrollY,
                i = c - o;
              let a = 0;
              const l = () => {
                a += 5;
                const e = Math.easeInOutQuad(a, o, i, 200);
                window.scrollTo(0, e), a < 200 && setTimeout(l, 5);
              };
              l();
            })(document.querySelector(t));
          });
        });
        const s = {};
        function u(e) {
          let t =
            arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : e;
          var n = l(e),
            r = n[0],
            c = n[n.length - 1];
          d(),
            (s.focusin = (t) => {
              (t.target !== e && t.target !== c && t.target !== r) ||
                document.addEventListener("keydown", s.keydown);
            }),
            (s.focusout = function () {
              document.removeEventListener("keydown", s.keydown);
            }),
            (s.keydown = function (t) {
              "TAB" === t.code.toUpperCase() &&
                (t.target !== c ||
                  t.shiftKey ||
                  (t.preventDefault(), r.focus()),
                (t.target !== e && t.target !== r) ||
                  !t.shiftKey ||
                  (t.preventDefault(), c.focus()));
            }),
            document.addEventListener("focusout", s.focusout),
            document.addEventListener("focusin", s.focusin),
            t.focus();
        }
        function d() {
          let e =
            arguments.length > 0 && void 0 !== arguments[0]
              ? arguments[0]
              : null;
          document.removeEventListener("focusin", s.focusin),
            document.removeEventListener("focusout", s.focusout),
            document.removeEventListener("keydown", s.keydown),
            e && e.focus();
        }
      },
    },
    t = {};
  function n(r) {
    var c = t[r];
    if (void 0 !== c) return c.exports;
    var o = (t[r] = { exports: {} });
    return e[r](o, o.exports, n), o.exports;
  }
  (n.d = function (e, t) {
    for (var r in t)
      n.o(t, r) &&
        !n.o(e, r) &&
        Object.defineProperty(e, r, { enumerable: !0, get: t[r] });
  }),
    (n.o = function (e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }),
    (function () {
      var e = n(4105),
        t = t || {};
      (t.money_format = "${{amount}}"),
        (t.formatMoney = function (e, t) {
          "string" == typeof e && (e = e.replace(".", ""));
          var n = "",
            r = /\{\{\s*(\w+)\s*\}\}/,
            c = t || this.money_format;
          function o(e, t) {
            return void 0 === e ? t : e;
          }
          function i(e, t, n, r) {
            if (
              ((t = o(t, 2)),
              (n = o(n, ",")),
              (r = o(r, ".")),
              isNaN(e) || null == e)
            )
              return 0;
            var c = (e = (e / 100).toFixed(t)).split(".");
            return (
              c[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + n) +
              (c[1] ? r + c[1] : "")
            );
          }
          switch (c.match(r)[1]) {
            case "amount":
              n = i(e, 2);
              break;
            case "amount_no_decimals":
              n = i(e, 0);
              break;
            case "amount_with_comma_separator":
              n = i(e, 2, ".", ",");
              break;
            case "amount_no_decimals_with_comma_separator":
              n = i(e, 0, ".", ",");
          }
          return c.replace(r, n);
        });
      const r = document.getElementById("mini-cart"),
        c = r.querySelector(".mini-cart__sidebar"),
        o = document.getElementById("overlay"),
        i = document.getElementById("cart-open"),
        a = document.querySelector("body"),
        l = () => {
          r.classList.remove("open"),
            window.setTimeout(() => {
              o.classList.remove("open");
            }, 1),
            a.style.removeProperty("overflow"),
            (0, e.hO)(!1);
        };
      i &&
        i.addEventListener("click", function () {
          r.classList.add("open"),
            window.setTimeout(() => {
              o.classList.add("open", "overlay--all");
            }, 1),
            document.body.classList.add("active", "minicart"),
            (0, e.gp)(!0, l),
            (0, e.hO)(!0),
            r.focus(),
            (0, e.St)(r, c);
        }),
        document
          .getElementById("cart-close")
          .addEventListener("click", function () {
            r.classList.remove("open"),
              window.setTimeout(() => {
                o.classList.remove("open", "overlay--all");
              }, 1),
              document.body.classList.remove("active", "minicart"),
              (0, e.hO)(!1),
              (0, e.zx)(r);
          }),
        o.addEventListener("click", () => {
          r.classList.remove("open"),
            window.setTimeout(() => {
              o.classList.remove("open", "overlay--all");
            }, 1),
            document.body.classList.remove("active", "minicart"),
            (0, e.hO)(!1),
            (0, e.zx)(r);
        });
      const s = (n) => {
        const o = n.items,
          i = document.getElementById("cart-total-price");
        document
          .querySelectorAll(".cart-count")
          .forEach((e) => (e.textContent = n.item_count));
        let a = n.items_subtotal_price / 100;
        (i.innerText = t.formatMoney(n.items_subtotal_price, `${currency}{{amount}}`)),
          0 === n.item_count
            ? ((document.querySelector(
                ".header__icons--cart-open.no-js-hidden .cart-count"
              ).style.display = "none"),
              (document.querySelector(".mini-cart--empty").style.display =
                "block"),
              document
                .querySelector(".cart-summary__buttons")
                .classList.add("disabled"))
            : ((document.querySelector(
                ".header__icons--cart-open.no-js-hidden .cart-count"
              ).style.display = "flex"),
              (document.querySelector(".mini-cart--empty").style.display =
                "none"),
              document
                .querySelector(".cart-summary__buttons")
                .classList.remove("disabled"));
        let l = document.createElement("div");
        l.classList.add("cart-items__container"),
          o.forEach((e) => {
            let n = document
              .querySelector(".empty-cart-item > .cart-item")
              .cloneNode(!0);
            n.setAttribute("data-variant-id", e.variant_id),
              n.querySelector(".cart-item__title").setAttribute("href", e.url),
              (n.querySelector(".cart-item__title").innerText = e.title),
              e.selling_plan_allocation &&
                (n.querySelector(".cart-item__selling-plan").innerText =
                  e.selling_plan_allocation.selling_plan.name);
            const c = e.unit_price;
            c &&
              ((n.querySelector(".unit-price").innerText = t.formatMoney(
                c,
                `${currency}{{amount}}`
              )),
              (n.querySelector(
                ".unit-price-reference-value"
              ).innerText = ` / ${e.unit_price_measurement.reference_value}`),
              (n.querySelector(
                ".unit-price-reference-unit"
              ).innerText = `${e.unit_price_measurement.reference_unit}`)),
              (n.querySelector('input[name="quantity"]').value = e.quantity);
            const o = e.discounts;
            if (
              (o &&
                o.length > 0 &&
                o.forEach((e) => {
                  n.querySelector(".cart-item__discounts").innerHTML +=
                    "<li><span class='icon loaded'>sell</span>" +
                    e.title +
                    "</li>";
                }),
              e.properties)
            ) {
              const t = Object.entries(e.properties);
              n
                .querySelector(".cart-item__properties")
                .classList.remove("u-hide"),
                t.forEach((e) => {
                  e[0].startsWith("_") ||
                    "" == e[1] ||
                    (n.querySelector(".cart-item__properties").innerHTML +=
                      "<p class='text-xs'><strong>" +
                      e[0] +
                      "</strong>: " +
                      e[1] +
                      "</p>");
                });
            }
            ((e) => {
              let t = !1;
              return (
                r.querySelectorAll(".cart-item").forEach((n) => {
                  t =
                    n.querySelector(".cart-item__title").textContent === e &&
                    n
                      .querySelector(".cart-item-image")
                      .getAttribute("data-src")
                      .indexOf("no-image") > -1;
                }),
                t
              );
            })(e.title) ||
              (e.featured_image.url
                ? n
                    .querySelector(".cart-item-image")
                    .setAttribute(
                      "data-src",
                      e.featured_image.url
                        .replace(".jpg", "_150x150.jpg")
                        .replace(".png", "_150x150.png")
                    )
                : (n.querySelector(".cart-item__image figure").innerHTML =
                    '<svg class="img-placeholder" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 525.5 525.5"><path d="M375.5 345.2c0-.1 0-.1 0 0 0-.1 0-.1 0 0-1.1-2.9-2.3-5.5-3.4-7.8-1.4-4.7-2.4-13.8-.5-19.8 3.4-10.6 3.6-40.6 1.2-54.5-2.3-14-12.3-29.8-18.5-36.9-5.3-6.2-12.8-14.9-15.4-17.9 8.6-5.6 13.3-13.3 14-23 0-.3 0-.6.1-.8.4-4.1-.6-9.9-3.9-13.5-2.1-2.3-4.8-3.5-8-3.5h-54.9c-.8-7.1-3-13-5.2-17.5-6.8-13.9-12.5-16.5-21.2-16.5h-.7c-8.7 0-14.4 2.5-21.2 16.5-2.2 4.5-4.4 10.4-5.2 17.5h-48.5c-3.2 0-5.9 1.2-8 3.5-3.2 3.6-4.3 9.3-3.9 13.5 0 .2 0 .5.1.8.7 9.8 5.4 17.4 14 23-2.6 3.1-10.1 11.7-15.4 17.9-6.1 7.2-16.1 22.9-18.5 36.9-2.2 13.3-1.2 47.4 1 54.9 1.1 3.8 1.4 14.5-.2 19.4-1.2 2.4-2.3 5-3.4 7.9-4.4 11.6-6.2 26.3-5 32.6 1.8 9.9 16.5 14.4 29.4 14.4h176.8c12.9 0 27.6-4.5 29.4-14.4 1.2-6.5-.5-21.1-5-32.7zm-97.7-178c.3-3.2.8-10.6-.2-18 2.4 4.3 5 10.5 5.9 18h-5.7zm-36.3-17.9c-1 7.4-.5 14.8-.2 18h-5.7c.9-7.5 3.5-13.7 5.9-18zm4.5-6.9c0-.1.1-.2.1-.4 4.4-5.3 8.4-5.8 13.1-5.8h.7c4.7 0 8.7.6 13.1 5.8 0 .1 0 .2.1.4 3.2 8.9 2.2 21.2 1.8 25h-30.7c-.4-3.8-1.3-16.1 1.8-25zm-70.7 42.5c0-.3 0-.6-.1-.9-.3-3.4.5-8.4 3.1-11.3 1-1.1 2.1-1.7 3.4-2.1l-.6.6c-2.8 3.1-3.7 8.1-3.3 11.6 0 .2 0 .5.1.8.3 3.5.9 11.7 10.6 18.8.3.2.8.2 1-.2.2-.3.2-.8-.2-1-9.2-6.7-9.8-14.4-10-17.7 0-.3 0-.6-.1-.8-.3-3.2.5-7.7 3-10.5.8-.8 1.7-1.5 2.6-1.9h155.7c1 .4 1.9 1.1 2.6 1.9 2.5 2.8 3.3 7.3 3 10.5 0 .2 0 .5-.1.8-.3 3.6-1 13.1-13.8 20.1-.3.2-.5.6-.3 1 .1.2.4.4.6.4.1 0 .2 0 .3-.1 13.5-7.5 14.3-17.5 14.6-21.3 0-.3 0-.5.1-.8.4-3.5-.5-8.5-3.3-11.6l-.6-.6c1.3.4 2.5 1.1 3.4 2.1 2.6 2.9 3.5 7.9 3.1 11.3 0 .3 0 .6-.1.9-1.5 20.9-23.6 31.4-65.5 31.4h-43.8c-41.8 0-63.9-10.5-65.4-31.4zm91 89.1h-7c0-1.5 0-3-.1-4.2-.2-12.5-2.2-31.1-2.7-35.1h3.6c.8 0 1.4-.6 1.4-1.4v-14.1h2.4v14.1c0 .8.6 1.4 1.4 1.4h3.7c-.4 3.9-2.4 22.6-2.7 35.1v4.2zm65.3 11.9h-16.8c-.4 0-.7.3-.7.7 0 .4.3.7.7.7h16.8v2.8h-62.2c0-.9-.1-1.9-.1-2.8h33.9c.4 0 .7-.3.7-.7 0-.4-.3-.7-.7-.7h-33.9c-.1-3.2-.1-6.3-.1-9h62.5v9zm-12.5 24.4h-6.3l.2-1.6h5.9l.2 1.6zm-5.8-4.5l1.6-12.3h2l1.6 12.3h-5.2zm-57-19.9h-62.4v-9h62.5c0 2.7 0 5.8-.1 9zm-62.4 1.4h62.4c0 .9-.1 1.8-.1 2.8H194v-2.8zm65.2 0h7.3c0 .9.1 1.8.1 2.8H259c.1-.9.1-1.8.1-2.8zm7.2-1.4h-7.2c.1-3.2.1-6.3.1-9h7c0 2.7 0 5.8.1 9zm-7.7-66.7v6.8h-9v-6.8h9zm-8.9 8.3h9v.7h-9v-.7zm0 2.1h9v2.3h-9v-2.3zm26-1.4h-9v-.7h9v.7zm-9 3.7v-2.3h9v2.3h-9zm9-5.9h-9v-6.8h9v6.8zm-119.3 91.1c-2.1-7.1-3-40.9-.9-53.6 2.2-13.5 11.9-28.6 17.8-35.6 5.6-6.5 13.5-15.7 15.7-18.3 11.4 6.4 28.7 9.6 51.8 9.6h6v14.1c0 .8.6 1.4 1.4 1.4h5.4c.3 3.1 2.4 22.4 2.7 35.1 0 1.2.1 2.6.1 4.2h-63.9c-.8 0-1.4.6-1.4 1.4v16.1c0 .8.6 1.4 1.4 1.4H256c-.8 11.8-2.8 24.7-8 33.3-2.6 4.4-4.9 8.5-6.9 12.2-.4.7-.1 1.6.6 1.9.2.1.4.2.6.2.5 0 1-.3 1.3-.8 1.9-3.7 4.2-7.7 6.8-12.1 5.4-9.1 7.6-22.5 8.4-34.7h7.8c.7 11.2 2.6 23.5 7.1 32.4.2.5.8.8 1.3.8.2 0 .4 0 .6-.2.7-.4 1-1.2.6-1.9-4.3-8.5-6.1-20.3-6.8-31.1H312l-2.4 18.6c-.1.4.1.8.3 1.1.3.3.7.5 1.1.5h9.6c.4 0 .8-.2 1.1-.5.3-.3.4-.7.3-1.1l-2.4-18.6H333c.8 0 1.4-.6 1.4-1.4v-16.1c0-.8-.6-1.4-1.4-1.4h-63.9c0-1.5 0-2.9.1-4.2.2-12.7 2.3-32 2.7-35.1h5.2c.8 0 1.4-.6 1.4-1.4v-14.1h6.2c23.1 0 40.4-3.2 51.8-9.6 2.3 2.6 10.1 11.8 15.7 18.3 5.9 6.9 15.6 22.1 17.8 35.6 2.2 13.4 2 43.2-1.1 53.1-1.2 3.9-1.4 8.7-1 13-1.7-2.8-2.9-4.4-3-4.6-.2-.3-.6-.5-.9-.6h-.5c-.2 0-.4.1-.5.2-.6.5-.8 1.4-.3 2 0 0 .2.3.5.8 1.4 2.1 5.6 8.4 8.9 16.7h-42.9v-43.8c0-.8-.6-1.4-1.4-1.4s-1.4.6-1.4 1.4v44.9c0 .1-.1.2-.1.3 0 .1 0 .2.1.3v9c-1.1 2-3.9 3.7-10.5 3.7h-7.5c-.4 0-.7.3-.7.7 0 .4.3.7.7.7h7.5c5 0 8.5-.9 10.5-2.8-.1 3.1-1.5 6.5-10.5 6.5H210.4c-9 0-10.5-3.4-10.5-6.5 2 1.9 5.5 2.8 10.5 2.8h67.4c.4 0 .7-.3.7-.7 0-.4-.3-.7-.7-.7h-67.4c-6.7 0-9.4-1.7-10.5-3.7v-54.5c0-.8-.6-1.4-1.4-1.4s-1.4.6-1.4 1.4v43.8h-43.6c4.2-10.2 9.4-17.4 9.5-17.5.5-.6.3-1.5-.3-2s-1.5-.3-2 .3c-.1.2-1.4 2-3.2 5 .1-4.9-.4-10.2-1.1-12.8zm221.4 60.2c-1.5 8.3-14.9 12-26.6 12H174.4c-11.8 0-25.1-3.8-26.6-12-1-5.7.6-19.3 4.6-30.2H197v9.8c0 6.4 4.5 9.7 13.4 9.7h105.4c8.9 0 13.4-3.3 13.4-9.7v-9.8h44c4 10.9 5.6 24.5 4.6 30.2z"/><path d="M286.1 359.3c0 .4.3.7.7.7h14.7c.4 0 .7-.3.7-.7 0-.4-.3-.7-.7-.7h-14.7c-.3 0-.7.3-.7.7zm5.3-145.6c13.5-.5 24.7-2.3 33.5-5.3.4-.1.6-.5.4-.9-.1-.4-.5-.6-.9-.4-8.6 3-19.7 4.7-33 5.2-.4 0-.7.3-.7.7 0 .4.3.7.7.7zm-11.3.1c.4 0 .7-.3.7-.7 0-.4-.3-.7-.7-.7H242c-19.9 0-35.3-2.5-45.9-7.4-.4-.2-.8 0-.9.3-.2.4 0 .8.3.9 10.8 5 26.4 7.5 46.5 7.5h38.1zm-7.2 116.9c.4.1.9.1 1.4.1 1.7 0 3.4-.7 4.7-1.9 1.4-1.4 1.9-3.2 1.5-5-.2-.8-.9-1.2-1.7-1.1-.8.2-1.2.9-1.1 1.7.3 1.2-.4 2-.7 2.4-.9.9-2.2 1.3-3.4 1-.8-.2-1.5.3-1.7 1.1s.2 1.5 1 1.7z"/><path d="M275.5 331.6c-.8 0-1.4.6-1.5 1.4 0 .8.6 1.4 1.4 1.5h.3c3.6 0 7-2.8 7.7-6.3.2-.8-.4-1.5-1.1-1.7-.8-.2-1.5.4-1.7 1.1-.4 2.3-2.8 4.2-5.1 4zm5.4 1.6c-.6.5-.6 1.4-.1 2 1.1 1.3 2.5 2.2 4.2 2.8.2.1.3.1.5.1.6 0 1.1-.3 1.3-.9.3-.7-.1-1.6-.8-1.8-1.2-.5-2.2-1.2-3-2.1-.6-.6-1.5-.6-2.1-.1zm-38.2 12.7c.5 0 .9 0 1.4-.1.8-.2 1.3-.9 1.1-1.7-.2-.8-.9-1.3-1.7-1.1-1.2.3-2.5-.1-3.4-1-.4-.4-1-1.2-.8-2.4.2-.8-.3-1.5-1.1-1.7-.8-.2-1.5.3-1.7 1.1-.4 1.8.1 3.7 1.5 5 1.2 1.2 2.9 1.9 4.7 1.9z"/><path d="M241.2 349.6h.3c.8 0 1.4-.7 1.4-1.5s-.7-1.4-1.5-1.4c-2.3.1-4.6-1.7-5.1-4-.2-.8-.9-1.3-1.7-1.1-.8.2-1.3.9-1.1 1.7.7 3.5 4.1 6.3 7.7 6.3zm-9.7 3.6c.2 0 .3 0 .5-.1 1.6-.6 3-1.6 4.2-2.8.5-.6.5-1.5-.1-2s-1.5-.5-2 .1c-.8.9-1.8 1.6-3 2.1-.7.3-1.1 1.1-.8 1.8 0 .6.6.9 1.2.9z"/></svg>'));
            let a = e.final_line_price / 100;
            var s;
            (n.querySelector(".cart-item-subtotal").innerText = `${currency}${
              ((s = a),
              s
                .toFixed(2)
                .toString()
                .replace(/\B(?=(\d{3})+(?!\d))/g, ","))
            }`),
              l.appendChild(n);
          }),
          (r.querySelector(".cart-items__container").innerHTML = l.innerHTML),
          r.querySelectorAll(".cart-item").forEach((e, t) => {
            (e.querySelector('input[name="quantity"]').value = o[t].quantity),
              d(e);
          }),
          r.querySelectorAll("img").forEach((e) => {
            "" == e.src && (e.src = e.dataset.src);
          });

// Check if currency conversion should be applied based on theme setting
const shouldConvertCurrency = window.theme_settings?.enable_currency_conversion === true;

// Calculate threshold and remaining amount based on the toggle
let adjustedThreshold, remainingAmount;

if (shouldConvertCurrency && window.Shopify?.currency?.rate) {
  // Apply currency conversion
  adjustedThreshold = freeShippingThreshold * window.Shopify.currency.rate;
  remainingAmount = adjustedThreshold - a;
} else {
  // Use original threshold without conversion
  adjustedThreshold = freeShippingThreshold;
  remainingAmount = adjustedThreshold - a;
}

// Check if free shipping elements exist
if (r.querySelector(".free-shipping-left")) {
  
  // Update the amount left for free shipping
  r.querySelector(".free-shipping-left > #amount-left").innerText = currency + remainingAmount.toFixed(2);

  // Calculate the progress percentage
  const progressPercent = Math.min((a / adjustedThreshold) * 100, 100);

  // Update the data-percentage attribute dynamically
  r.querySelector(".free-shipping-left").setAttribute(
    "data-percentage",
    progressPercent.toFixed(2)
  );

  // Update the progress bar width dynamically with animation
  const progressBar = r.querySelector(".progress-value");

  // Reset the width first to ensure animation works on consecutive updates
  progressBar.style.transition = 'none'; // Disable transition for the reset
  progressBar.style.width = '0%'; // Reset width to trigger the transition

  // Force reflow to apply the width reset immediately
  progressBar.offsetHeight; // This forces a reflow (a necessary trick)

  // Now animate the width with a smooth transition
  progressBar.style.transition = 'width 0.5s ease'; // Re-enable transition
  progressBar.style.width = progressPercent + "%"; // Update the width with transition

  // Show or hide the correct message
  if (adjustedThreshold <= a) {
    r.querySelector(".free-shipping-left").style.display = "none";
    r.querySelector(".free-shipping-qualified").style.display = "block";
  } else {
    r.querySelector(".free-shipping-left").style.display = "block";
    r.querySelector(".free-shipping-qualified").style.display = "none";
  }

  // Add visual feedback for adding items to the cart
  document.body.classList.add("active", "addtocart");
  window.setTimeout(() => {
    document.body.classList.remove("active", "addtocart");
  }, 2000);

  // Set focus on the cart close button
  document.getElementById("cart-close").focus();

  // Call a cart update function
  (0, e.St)(r, c);
}
          document.body.classList.add("active", "addtocart"),
          window.setTimeout(
            () => document.body.classList.remove("active", "addtocart"),
            2e3
          ),
          document.getElementById("cart-close").focus(),
          (0, e.St)(r, c);

      };
      new MutationObserver(function (e, t) {
        e.forEach(function (e) {
          "attributes" === e.type &&
            "class" === e.attributeName &&
            fetch("/cart.js")
              .then((e) => e.json())
              .then((e) => {
                s(e);
              });
        });
      }).observe(r, { attributes: !0 });
      const u = (t) => {
          const n = JSON.stringify(t);
          fetch(`${routes.cartChange}`, { ...(0, e.Q2)(), body: n })
            .then((e) => e.json())
            .then(function (e) {
              s(e),
                t.quantity > e.item_count &&
                  (document.querySelector(
                    '.cart-item[data-variant-id="' +
                      e.items[0].id +
                      '"] .cart-item__error'
                  ).innerHTML = window.cartStrings.quantityError.replace(
                    "[quantity]",
                    e.item_count
                  ));
            })
            .catch((e) => {
              console.error("Error:", e);
            });
        },
        d = (e) => {
          const t = e.getAttribute("data-variant-id"),
            n = e.querySelector('input[name="quantity"]'),
            r = e.querySelector(".cart-item-delete");
          let c = parseInt(n.value);
          const o = e.querySelector('.quantity button[name="plus"]'),
            i = e.querySelector('.quantity button[name="minus"]');
          o.addEventListener("click", function () {
            (c += 1), (n.value = c), u({ id: t, quantity: c });
          }),
            i.addEventListener("click", function () {
              (c -= 1), (n.value = c), u({ id: t, quantity: c });
            }),
            r.addEventListener("click", function () {
              u({ id: t, quantity: 0 }), e.remove();
            });
        };
      r.querySelectorAll(".cart-item").forEach((e) => {
        d(e);
      }),
        document.querySelector(".header__icons--cart-open") &&
          ("0" ===
          document.querySelector(
            ".header__icons--cart-open.no-js-hidden .cart-count"
          ).textContent
            ? (document.querySelector(
                ".header__icons--cart-open.no-js-hidden .cart-count"
              ).style.display = "none")
            : (document.querySelector(
                ".header__icons--cart-open.no-js-hidden .cart-count"
              ).style.display = "flex")),
        document
          .getElementById("overlay")
          .insertAdjacentElement(
            "beforebegin",
            document.getElementById("mini-cart")
          );
    })();
})();
